import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EndPointService {
  baseUri: any = "http://muypiapp-001-site1.gtempurl.com/public/api"
  constructor() { }

  itemRef(){
    
  }

}
